var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.6875V8.5125C16.5 9.465 16.185 10.2675 15.6225 10.8225C15.0675 11.385 14.265 11.7 13.3125 11.7V13.0575C13.3125 13.5675 12.7425 13.875 12.3225 13.59L11.595 13.11C11.6625 12.8775 11.6925 12.6225 11.6925 12.3525V9.3C11.6925 7.77 10.6725 6.75 9.1425 6.75H4.05C3.945 6.75 3.8475 6.7575 3.75 6.765V4.6875C3.75 2.775 5.025 1.5 6.9375 1.5H13.3125C15.225 1.5 16.5 2.775 16.5 4.6875Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6925 9.3V12.3525C11.6925 12.6225 11.6625 12.8775 11.595 13.11C11.3175 14.2125 10.4025 14.9025 9.1425 14.9025H7.1025L4.8375 16.41C4.76157 16.462 4.67285 16.4921 4.58097 16.4972C4.4891 16.5023 4.39759 16.4821 4.3164 16.4388C4.23522 16.3955 4.16745 16.3307 4.12048 16.2516C4.07351 16.1725 4.04914 16.082 4.05 15.99V14.9025C3.285 14.9025 2.6475 14.6475 2.205 14.205C1.755 13.755 1.5 13.1175 1.5 12.3525V9.3C1.5 7.875 2.385 6.8925 3.75 6.765C3.8475 6.7575 3.945 6.75 4.05 6.75H9.1425C10.6725 6.75 11.6925 7.77 11.6925 9.3V9.3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "transparent"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.d3224f0fd40df13add1f83f3829a7614.svg";
export { ForwardRef as ReactComponent };